import React from 'react';

import { DateFormat, formatDate } from '@lyearn/core/utils/date/formatDate';
import { useArticle } from '@/modules/corporate/modules/article/articleContext';

import Author from './Author';
import { AuthorContainerProps } from './types';

const AuthorContainer: React.FC<AuthorContainerProps> = () => {
  const {
    article: {
      author: { name, picture },
      createdAt,
      sharedByWorkspace,
    },
  } = useArticle();

  if (sharedByWorkspace) {
    return null;
  }

  const authorItem = {
    name,
    createdAt: formatDate(createdAt, DateFormat.DayDate),
    picture: picture ?? '',
  };

  return <Author {...authorItem} />;
};

export default React.memo(AuthorContainer);
